// Module
var code = "<template> <require from=\"./modal-footer.scss\"></require> <slot name=\"buttons\"></slot> <slot></slot> </template> ";
// Exports
module.exports = code;